/** Strip leading placeholder dashes from legacy recipe card titles. */
export function formatRecipeCardTitle(value: string | null | undefined, fallback = "Recipe"): string {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return fallback;
  const cleaned = trimmed.replace(/^(\s*[—–-]\s*)+/u, "").trim();
  return cleaned || fallback;
}
